import React from "react";
import { Translation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { Row, Col, FormGroup, Input, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";
import { Form, Field } from "react-final-form";
import CustomerService from "../Customer.service";
import AuthService from "../../../Authentication/auth.service";

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../../components/Loaders/DnaLoader";
import "../../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../../components/Alerts/alerts";;


class DocsAddCustomer extends React.Component {
  constructor(props) {
    super(props);
    console.log("Received Prop:-", props);
    this.state = {
      modal: false,
      Name: '',
      Email: '',
      Status: '',
      backdrop: true,
      loading: false,
      loginNavigate: false,
      docTypes: [],
      upfile: ''
    };
    this.toggle = this.toggle.bind(this);
    this.validateFtn = this.validateFtn.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  validateFtn = values => {
    const errors = {};
    if (!this.state.Name === '') {
      errors.email = "Email Required.";
    }
    if (!this.state.Email === '') {
      errors.name = "Name Required.";
    }
    if (!this.state.Status === '') {
      errors.status = "Status Required.";
    }

    return errors;
  };

  onSubmit = values => {
    console.log(values);
    var payloadData = {
      functionName: "AddContact",
      postData: {
        name: this.state.Name,
        email: this.state.Email,
        status: this.state.Status,
        user_id: this.props.data,
      }
    }
    this.setState({
      loading: !this.state.loading,
    });
    CustomerService.AddContact(payloadData).then((response) => {
      console.log("API Response:-", response);
      this.setState({
        loading: !this.state.loading,
      });
      if (response.data.status) {
        this.props.onSuccess();
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message).then(res => {
            console.log("Resp:-", res)
            this.toggle();
          })
        }
        else {
          Alerts.swalSuccessAlert("Contact added successfully.").then(res => {
            console.log("Resp:-", res)
            this.toggle();
          })
        }
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            this.setState({ loginNavigate: true });
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message).then(res => {
              console.log("Resp:-", res)
            })
          }
        }
        else {
          Alerts.swalErrorAlert("Error: Can't Add Document at the moment. Please try again later.")
        }
      }
    },
      (error) => {
        this.setState({
          loading: !this.state.loading,
        });
        const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        Alerts.swalErrorAlert("Network Operation failed.")
      });

  }

  render() {
    {
      this.state.loginNavigate &&
        <Navigate to={'/login'} />
    }
    return (
      <Translation>
        {(t) => (
          <span className="d-inline-block float-end mb-2 me-2">
            <a onClick={this.toggle} className="btn btn-custom-color btn-hover-shine ms-1">
              {t("Add New")}
            </a>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={true}>
              <LoadingOverlay tag="div" active={this.state.loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}>
                <ModalHeader>{t("Add Contact")}</ModalHeader>
                <ModalBody>
                  <Card className="main-card mb-3">
                    <CardBody>
                      <Row>
                        <Col md="12" className="pt-3">
                          <Form onSubmit={this.onSubmit}
                            validate={this.validateFtn}
                            render={({ handleSubmit, values, submitting, validating, valid }) => (
                              <form onSubmit={handleSubmit}>
                                <Row>
                                  <Col md="12">
                                    <FormGroup>
                                      <div className="mb-12" >
                                        <Label className="mb-2">{t("Name")}</Label>
                                        <Field name="name">
                                          {({ input, meta }) => (
                                            <div>
                                              <Input {...input} type="text"
                                                placeholder="Enter your name"
                                                value={this.state.Name}
                                                onChange={(e) => {
                                                  this.setState({ Name: e.target.value });
                                                }}
                                                invalid={meta.error && meta.touched}
                                              >
                                              </Input>
                                              {meta.error && meta.touched &&
                                                <span className="text-danger">{meta.error}</span>}
                                            </div>
                                          )}
                                        </Field>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md="12" >
                                    <FormGroup>
                                      <div className="mb-12">
                                        <Label className="mb-2">{t("Email")}</Label>
                                        <Field name="email">
                                          {({ input, meta }) => (
                                            <div>
                                              <Input {...input} name="email"
                                                value={this.state.Email}
                                                onChange={(e) => { this.setState({ Email: e.target.value }); }}
                                                placeholder="Enter your email address"
                                                type='email' />
                                              {meta.error && meta.touched &&
                                                <span className="text-danger">{meta.error}</span>}
                                            </div>
                                          )}
                                        </Field>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md="12" >
                                    <FormGroup>
                                      <div className="mb-12">
                                        <Label className="mb-2">{t("Status")}</Label>
                                        <Field name="status">
                                          {({ input, meta }) => (
                                            <div>
                                              <Input {...input} type="select"
                                                value={this.state.Status}
                                                placeholder="select Status"
                                                onChange={(e) => { this.setState({ Status: e.target.value }); }}
                                              >
                                                <option disabled={true} value="">{t("Select Status")}</option>
                                                <option key={'Active'} value="Active">{t("Active")}</option>
                                                <option key={'InActive'} value="InActive">{t("InActive")}</option>
                                              </Input>
                                              {meta.error && meta.touched &&
                                                <span className="text-danger">{meta.error}</span>}
                                            </div>
                                          )}
                                        </Field>
                                      </div>
                                    </FormGroup>
                                  </Col>


                                  <div className="text-center">
                                    <FormGroup>
                                      <div className="text-center">
                                        <button type="submit" className="btn btn-secondary btn-lg btn-hover-shine me-3">
                                          {t("Add")} </button>
                                        <button type="button" className="btn btn-outline-success btn-lg btn-hover-shine me-3" onClick={this.toggle}>
                                          {t("Cancel")}
                                        </button>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Row>
                              </form>
                            )}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </ModalBody>
              </LoadingOverlay>
            </Modal>
          </span>
        )
        }
      </Translation>
    );
  };


};

export default DocsAddCustomer;